import { Button, Modal } from 'antd';

import styles from './OverlapWarningModal.module.scss';

type Props = {
  isOpen: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const OverlapWarningModal = ({
  isOpen,
  isLoading,
  onCancel,
  onConfirm,
}: Props) => (
  <Modal
    className={styles.modal}
    wrapClassName={styles.overlapWarningModal}
    width={572}
    open={isOpen}
    title="Some slots already exist on these days"
    onCancel={onCancel}
    footer={[
      <Button key="back" type="ghost" onClick={onCancel}>
        Back to edit
      </Button>,
      <Button key="save" type="primary" onClick={onConfirm} loading={isLoading}>
        Save anyway
      </Button>,
    ]}
  >
    <p>
      <span className={styles.bold}>
        You're saving a recurring slot that conflicts with existing ones.
      </span>
    </p>
    <p>
      Both slots will appear on the calendar. But only the one with the higher
      capacity count will be taken into account for bookings.
    </p>
  </Modal>
);
